import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { default as infoIcon } from "../../assets/images/infobtnblue.svg";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import { GetList } from "../../services/ReduxTookit/Slice/IndustryRedux";
import { UpdateMachine, UpdateReviewComment } from "../../services/ReduxTookit/Slice/MachineRedux";
import { CategoryGetListDetail } from "../../services/ReduxTookit/Slice/CategoryRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { createPortal } from "react-dom";

const Classification = ({
  getlist,
  machineId,
  handleclose,
  bindlist,
  versionlist,
  updatereviewcommentdata,
  geteditstatus,
  setmachinedetails,
}) => {
  const countFalseValues = () => {
    return Object.values(geteditstatus).filter((value) => value === false)
      .length;
  };
  const [IndustryList, setIndustryList] = useState([]);
  const [CategoryList, setCategoryList] = useState([]);
  const [MachineLoader, setMachineLoader] = useState(false);
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    machineid: machineId ? machineId : 0,
    price: "",
    subcategoryid: 0,
    subcategoryname: "",
    title: "",
    isprivate: false,
    industryid: "",
    industryname: "",
    categoryid: "",
    categoryname: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: [],
    dependentmachineids: [],
    cloud: [],
    errors: {
      machineid: "",
      categoryid: "",
      industryid: "",
      subcategoryid: "",
      ValidationRules: [
        {
          FieldName: "categoryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "industryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "subcategoryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  async function getCategoryList() {
    let body = {
      categoryname: "",
    };
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.CATEGORYGETLIST,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(false, resData);
    dispatch(CategoryGetListDetail(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setCategoryList(response?.payload?.data?.data);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }

  async function getIndustryList() {
    let body = {
      industryname: "",
    };

    dispatch(GetList(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setIndustryList(res?.payload?.data?.data);
      } else {
      }
    });

    //  ------------ Before Redux
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.INDUSTRYGETLIST,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(false, resData);
    // if (response?.isValidate) {
    //   setIndustryList(response?.data?.data);
    // }
    // if (!response?.isValidate) {
    // }
  }

  useEffect(() => {
    if (getlist) {
      setInput({
        ...input,
        machineid: getlist?.dataList1[0]?.machineid
          ? getlist?.dataList1[0]?.machineid
          : 0,
        price: getlist?.dataList1[0]?.price ? getlist?.dataList1[0]?.price : 0,
        subcategoryid: getlist?.dataList1[0]?.subcategoryid
          ? getlist?.dataList1[0]?.subcategoryid
          : 0,
        title: getlist?.dataList2[0]?.title ? getlist?.dataList2[0]?.title : "",
        industryid: getlist?.dataList1[0]?.industryid
          ? getlist?.dataList1[0]?.industryid
          : 0,
        categoryid: getlist?.dataList1[0]?.categoryid
          ? getlist?.dataList1[0]?.categoryid
          : 0,
        osrequirmet: getlist?.dataList2[0]?.osrequirmet
          ? getlist?.dataList2[0]?.osrequirmet
          : "",
        storage: getlist?.dataList2[0]?.storage
          ? getlist?.dataList2[0]?.storage
          : "",
        ram: getlist?.dataList2[0]?.ram ? getlist?.dataList2[0]?.ram : "",
        cpu: getlist?.dataList2[0]?.cpu ? getlist?.dataList2[0]?.cpu : "",
        cloud: getlist?.dataList2[0]?.cloud ? getlist?.dataList2[0]?.cloud : "",
        compatiblemachineids: getlist?.dataList2[0]?.compatiblemachineids
          ? getlist?.dataList2[0]?.compatiblemachineids
          : [],
        dependentmachineids: getlist?.dataList2[0]?.dependentmachineids
          ? getlist?.dataList2[0]?.dependentmachineids
          : [],
        industryname: getlist?.dataList1[0]?.industryname
          ? getlist?.dataList1[0]?.industryname
          : "",
        categoryname: getlist?.dataList1[0]?.categoryname
          ? getlist?.dataList1[0]?.categoryname
          : "",
        subcategoryname: getlist?.dataList1[0]?.subcategoryname
          ? getlist?.dataList1[0]?.subcategoryname
          : "",
      });
    }
  }, [getlist]);
  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setMachineLoader(true);
      let newbody = {
        machineid: versionlist?.machineid,
        versionnumber: versionlist?.number,
        booleanfield: updatereviewcommentdata?.booleanfield,
        commentfield: updatereviewcommentdata?.commentfield,
        commentfieldvalue: updatereviewcommentdata?.commentfieldvalue,
      };
      // let updateReviewResponse = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_REVIEWR_COMMENT,
      //     body: newbody,
      //   },
      //   true
      // );
      // let response = apiResponse(false, updateReviewResponse);

      dispatch(UpdateReviewComment(newbody))?.then((response)=>{
        if (response?.payload?.isValidate) {
          handleUpdate();
        }
        if (!response?.payload?.isValidate) {
        }
      })
     
    }
  };
  const handleUpdate = async (e) => {
    // e.preventDefault();
    // let obj = commonservices.fnCheckValidationOfObject(input);
    // setInput({
    //   ...obj.obj,
    // });
    // if (obj.isValid) {
    //   setMachineLoader(true);
      let body = {
        machineid: parseInt(input?.machineid),
        industryid: input?.industryid ? input?.industryid : "",
        categoryid: input?.categoryid ? input?.categoryid : "",
        subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
        title: input?.title ? input?.title : "",
        price: input?.price ? input?.price : 0,
        osrequirmet: input?.osrequirmet ? input?.osrequirmet : "",
        storage: input?.storage ? input?.storage : "",
        ram: input?.ram ? input?.ram : "",
        cpu: input?.cpu ? input?.cpu : "",
        cloud: input?.cloud ? input?.cloud : "",
        compatiblemachineids: input?.compatiblemachineids
          ? input?.compatiblemachineids
          : "",
        dependentmachineids: input?.dependentmachineids
          ? input?.dependentmachineids
          : "",
      };
      if (input?.machinedocument?.size > 0) {
        body = { ...body, machinedocument: input?.machinedocument };
      }
      if (countFalseValues() === 1) {
        body = { ...body, status: "In Process" };
      } else {
        body = { ...body, status: "Rejected" };
      }
      // let resData = await apiCall(
      //   {
      //     method: "PUT",
      //     url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setMachineLoader);
      dispatch(UpdateMachine(body))?.then((response) => {
        if (response?.payload?.isValidate) {
          setMachineLoader(false);
          handleclose();
          // bindlist(input?.machineid);
          const updatedMachineDetails = {
            ...getlist,
            dataList1: getlist?.dataList1?.map((item, index) => ({
              ...item,
              industryname: input?.industryname,
              categoryname: input?.categoryname,
              subcategoryname: input?.subcategoryname,
            })),
          };
          setmachinedetails(updatedMachineDetails);
        }
        if (!response?.payload?.isValidate) {
          setMachineLoader(false);
        }
      });
    }
  
  const fnInputChange = (value, tag) => {
    const selectedIndustry = IndustryList?.find(
      (element) => parseInt(element?.industryid) === parseInt(value)
    );
    const selectedCategory = CategoryList?.find(
      (element) => parseInt(element?.categoryid) === parseInt(value)
    );
    // const selectedCategory = CategoryList?.find(
    //   (element) => parseInt(element?.categoryid) === parseInt(value)
    // );
    if (value) {
      if (tag === "categoryid") {
        setInput({
          ...input,
          [tag]: value,
          subcategoryid: 0,
          subcategoryname: "",
          categoryname: selectedCategory?.categoryname,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      }
      if (tag === "industryid") {
        setInput({
          ...input,
          [tag]: value,
          industryname: selectedIndustry.industryname,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      }
      if (tag === "subcategoryid") {
        setInput({
          ...input,
          [tag]: value,
          subcategoryid: value,
          subcategoryname: selectedCategory?.categoryname,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      }
      //  else {
      //   setInput({
      //     ...input,
      //     [tag]: value,
      //     errors: {
      //       ...input.errors,
      //       [tag]: "",
      //     },
      //   });
      // }
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };

  useEffect(() => {
    getCategoryList();
    getIndustryList();
  }, []);

  // Add or remove 'loadtime' class based on MachineLoader
  
   useEffect(() => {
    if (MachineLoader) {
      document.body.classList.add('loadtime');
    } 
    // else {
    //   document.body.classList.remove('loadtime');
    // }
  
    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove('loadtime');
    };
  }, [MachineLoader]); // Re-run this effect when MachineLoader changes
  const LoaderPortal = ({ children }) => {
      return createPortal(children, document.body);
    };  

  return (
    <div>
      {MachineLoader && (
              <LoaderPortal>
                <MainpageLoader />
              </LoaderPortal>
            )}
      <div className="machine-detail-main mt16 p-3">        
          {/* <h5 className="machine-detail-inner-title">Classification</h5>           */}
            <Form.Group className="form-group mb16">
              <Form.Label className="common-label">
                Industry<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="position-relative">
                <Form.Select
                  className="common-select"
                  value={input.industryid}
                  onChange={(e) =>
                    fnInputChange(parseInt(e.target.value), "industryid")
                  }
                  isInvalid={input?.errors?.industryid}
                >
                  <option value="">Select</option>
                  {IndustryList?.length > 0 &&
                    IndustryList?.map((item_cd, index_cd) => (
                      <option key={index_cd} value={item_cd?.industryid}>
                        {item_cd?.industryname}
                      </option>
                    ))}
                </Form.Select>
                {input.errors.industryid && (
                  <Form.Control.Feedback type="invalid">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={input.errors.industryid}
                      />
                    </span>
                  </Form.Control.Feedback>
                )}
              </div>
            </Form.Group>                    
            <Form.Group className="form-group mb16">
              <Form.Label className="common-label">
                Category<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="position-relative">
                <Form.Select
                  className="common-select"
                  value={input.categoryid}
                  onChange={(e) =>
                    fnInputChange(parseInt(e.target.value), "categoryid")
                  }
                  isInvalid={input?.errors?.categoryid}
                >
                  <option value="">Select</option>
                  {CategoryList?.length > 0 &&
                    CategoryList?.map(
                      (item_cd, index_cd) =>
                        item_cd?.refcategoryid === 0 && (
                          <option key={index_cd} value={item_cd?.categoryid}>
                            {item_cd?.categoryname}
                          </option>
                        )
                    )}
                </Form.Select>
                {input?.errors?.categoryid && (
                  <Form.Control.Feedback type="invalid">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={input.errors.categoryid}
                      />
                    </span>
                  </Form.Control.Feedback>
                )}
              </div>
            </Form.Group>                    
            <Form.Group className="form-group mb16">
              <Form.Label className="common-label">Sub Category</Form.Label>
              <div className="position-relative">
                <Form.Select
                  className="common-select"
                  value={input.subcategoryid}
                  onChange={(e) =>
                    fnInputChange(parseInt(e.target.value), "subcategoryid")
                  }
                  isInvalid={input?.errors?.subcategoryid}
                >
                  <option value="">Select</option>
                  {input?.categoryid > 0 &&
                    CategoryList?.length > 0 &&
                    CategoryList?.map(
                      (item_cd, index_cd) =>
                        parseInt(input?.categoryid) ===
                          parseInt(item_cd?.refcategoryid) && (
                          <option key={index_cd} value={item_cd?.categoryid}>
                            {item_cd?.categoryname}
                          </option>
                        )
                    )}
                </Form.Select>
                {input.errors.subcategoryid && (
                  <Form.Control.Feedback type="invalid">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={input.errors.subcategoryid}
                      />
                    </span>
                  </Form.Control.Feedback>
                )}
              </div>
            </Form.Group>                  
        <div className="machin-detail-footer-btns">
          <button className="grey-btn" onClick={() => handleclose()}>
            Cancel
          </button>
          <button
            className="blue-btn"
            disabled={MachineLoader}
            onClick={(e) => updateReviewStatus(e)}
            // onClick={(e) => handleUpdate(e)}
            // type="submit"
          >
            {MachineLoader ? (
              // <>
              //   <span>Loading</span>{" "}
              //   <Spinner
              //     className="ms-1"
              //     animation="border"
              //     role="status"
              //     size="sm"
              //   >
              //     <span className="visually-hidden">Loading...</span>
              //   </Spinner>
              // </>
              <SubmitLoading />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Classification;
